import { useEffect, useMemo } from 'react';
import { LOGGED_IN_USER_KEY } from '../../config';

const LAYERS = {
    NDVI: 'georisk:bmi_mosaic',
    VISIBLE_IMAGE: 'georisk:tci_mosaic',
    FIELD_WMS: 'georisk:heterogeneity_mosaic',
};

const NdviDataprovider = ({ layerData, setSource }) => {
    const user = useMemo(() => JSON.parse(localStorage.getItem(LOGGED_IN_USER_KEY)), []);

    const { isLayerVisible, layerStringCode, layerStringDate, type } = layerData;

    useEffect(() => {
        if (isLayerVisible === false || layerStringCode === '' || layerStringDate === '') {
            setSource(null);
            return;
        }
        console.log(layerData);
        setSource({
            url: `/api/layers/wms/${layerStringCode}?token=${user.token}`,
            params: {
                LAYERS: LAYERS[type],
                DATE: layerStringDate,
                MEPAR_CODE: layerStringCode,
                SRS: 'EPSG:23700',
            },
        });
    }, [isLayerVisible, layerStringCode, layerStringDate, user, type]);

    // this is a HOC
    return null;
};

export default NdviDataprovider;
